import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  modalContent: {
    display: "block",
    position: "absolute",
    width: "30%",
    left: "40%",
    padding: 20,
    borderRadius: 20,
  },
  modalTitle: {
    display: "flex",
    justifyContent: "space-between",
  },
}));

export default useStyles;
